import { doc, setDoc } from 'firebase/firestore';
import { ResultDocument } from '@/types/api';
import { db } from '../firebaseConfig';
import { convertBackToSnakeCaseRecursive } from '@/utils/snakeToCamelCase';

export async function setViewedDocument(searchId: string, document: ResultDocument) {
  const viewedDocRef = doc(db, 'searches', searchId, 'viewedDocuments', document.documentId);
  await setDoc(viewedDocRef, convertBackToSnakeCaseRecursive(document));
}
